import React from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from '@mui/material'
import { extractErrorMessage } from '../../utils/extractErrorMessage'
import { useSnackbar } from 'notistack'
import { useDeleteHtgIncentive } from '../../api/htg-incentive'

const Delete = ({ openDelete, data, onClose, refetch }) => {
  const { mutateAsync, isLoading } = useDeleteHtgIncentive()
  const { enqueueSnackbar } = useSnackbar()

  const onSuccess = () => {
    onClose()
    refetch()
  }

  const handleDelete = async () => {
    try {
      await mutateAsync({ id: data.id })
      enqueueSnackbar('Successfully removed.', { variant: 'success' })
      onClose()
      onSuccess()
    } catch (e) {
      enqueueSnackbar(extractErrorMessage(e), { variant: 'error' })
    }
  }

  return (
    <Dialog maxWidth='sm' open={openDelete}>
      <DialogTitle>Confirm Deletion</DialogTitle>
      <DialogContent dividers>
        <Typography>
          Are you sure you want to remove <b> {data.name} </b> from HTG incentive campaign ? This
          action cannot be undone.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button variant='outlined' onClick={onClose} disabled={isLoading}>
          Cancel
        </Button>
        <Button
          variant='contained'
          style={{ background: 'red', color: 'white' }}
          onClick={handleDelete}
          disabled={isLoading}
        >
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default Delete
